import View from './View';
import { Playground, PlaygroundState } from './Playground';

export enum GameMove {
	Uncover,
	Mark,
}

export const storageKey = {
	minesCount: 'minesweeper-mines-count',
	windowSize: 'minesweeper-window-size',
};

export class Model {
	private view: View;
	private playground: Playground;
	readonly height = 17;
	readonly width = 10;
	private readonly defaultMinesCount = 10;

	constructor() {
		this.view = new View();
		this.restart(this.getMinesCount());
		setInterval(() => {
			if (this.playground.state === PlaygroundState.Active) {
				this.view.renderTime(this.playground.startTime);
			}
		}, 1000);
	}

	getMinesCount() {
		let minesCountFromStorage = localStorage.getItem(storageKey.minesCount);
		return minesCountFromStorage ? parseInt(minesCountFromStorage) : this.defaultMinesCount;
	}

	restart(minesCount: number) {
		localStorage.setItem(storageKey.minesCount, minesCount.toString());
		this.playground = new Playground(this.height, this.width, minesCount);
		this.view.createPlayground(this.playground);
		this.view.renderPlayground(this.playground);
		this.view.renderTime(this.playground.startTime);
	}

	controllPlayground(move: GameMove, positionY: number, positionX: number) {
		if (this.playground.state !== PlaygroundState.Active) return;
		if (move === GameMove.Uncover) {
			this.playground.uncoverPosition(positionY, positionX);
		} else {
			this.playground.markPositionToggle(positionY, positionX);
		}
		this.playground.checkEnd();
		this.view.renderPlayground(this.playground);
	}
}
